import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const computerUseWeb: PluginWebManifest = {
  // computer-use is a no-page plugin — it contributes a "Desktop" agent tab
  // backed by the on-devbox virtual display. The overview card is written by
  // hand so the plugin detail page renders a rich About section; `to`
  // targets the canonical plugin detail page since there is no standalone
  // page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/computer-use',
      label: 'Computer Use',
      icon: 'MonitorPlay',
      description: 'Give agents a virtual desktop with computer use and browser use tools.',
      details:
        'Turn on the "computer use" capability when launching an agent to give it a virtual ' +
        'desktop, plus MCP tools to see and control it: computer use (screenshot, click, type, ' +
        'scroll) for any GUI app, and browser use (Playwright) driving a Chromium that renders ' +
        'on the same desktop. A Desktop tab on the agent page streams the display live, so you ' +
        'can watch the agent work or grab the mouse yourself.',
      features: [
        'Opt-in per launch via the "computer use" devbox capability',
        'A full desktop: panel, file manager, terminal, text editor, and browser',
        '"Desktop" tab with a live view of the agent\'s virtual display',
        'Computer-use MCP tools: screenshot, click, type, key, scroll, drag',
        'Browser-use MCP tools: Playwright driving a visible Chromium',
        'Interactive live view: take over the desktop when the agent gets stuck',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: 'computer-use-desktop',
      label: 'Desktop',
      icon: 'MonitorPlay',
      componentPath: '@reflex/plugin-computer-use/web/DesktopTab',
      // Only show for agents launched with the computer-use capability on.
      requiresSandboxCapability: 'computerUse',
    },
  ],
  marketingPreviews: [
    {
      id: 'computer-use-desktop-panel',
      label: 'Desktop live view',
      description:
        'How the Desktop tab surfaces inside an agent: the live virtual display the agent is ' +
        'driving, streamed into the agent panel.',
      surface: 'panel',
      componentPath: '@reflex/plugin-computer-use/web/DesktopTabPreview',
    },
  ],
};
